// Subscription plans and pricing. MUST stay in sync with backend config.price_*.
import { Star } from "lucide-react";
import { Stars } from "./emoji.jsx";
import { C, BRAND } from "../design-system.js";

// ── Pricing ───────────────────────────────────────────────────────────────────
// ⚠️ These MUST equal backend config.price_* / config.stars_* exactly. The app only
// DISPLAYS them; the invoice is generated server-side from the backend values, so a
// mismatch would quote one price and charge another. `price`/`stars` are written out
// literally (not derived) for that reason — the backend rounds to whole thousands,
// which a BASE × months × discount formula here would not reproduce.
export const BASE = 890000;        // == backend price_1month
export const STAR_BASE = 400;      // == backend stars_1month
// Flip to true once SnappPay merchant OAuth is authenticated + a live token works.
// Turned back OFF 2026-08-11 at the user's request until SnappPay fixes the
// gateway's 403 RBAC error (it still isn't whitelisting our merchant IP).
export const SNAPPPAY_ENABLED = false;
// SnappPay's brand blue, taken from their official logo SVG (snapppay.ir).
export const SNAPP_BLUE = BRAND.snapp;
// DigiPay's brand blue — the fill of their own app mark (mydigipay.com
// /bck-assets/images/logos/dp-logo.svg), not a guess.
export const DIGI_BLUE = BRAND.digipay;
export const SUBSCRIPTION_PLANS = [
  { id: 1, months: 1, label: "۱ ماهه",  price:  890000, originalPrice: null,        discount: 0,  color: C.gold,    stars:  400, starsOriginal: null            },
  { id: 2, months: 2, label: "۲ ماهه",  price: 1727000, originalPrice: BASE * 2,    discount: 3,  color: C.teal,    stars:  775, starsOriginal: STAR_BASE * 2, bonus: 2 },
  { id: 3, months: 3, label: "۳ ماهه",  price: 2483000, originalPrice: BASE * 3,    discount: 7,  color: C.purple, stars: 1115, starsOriginal: STAR_BASE * 3, badge: "بسته پیشنهادی", bonus: 4 },
];
// `bonus` = FREE extra stories on that plan — DISPLAY only; the real count comes
// from backend/services/plans.py (settings.bonus_stories_*). Keep the two equal.
export const planStories = (plan) => plan.months * 8 + (plan.bonus || 0);

// The 5-day money-back guarantee (2026-11-03) — DISPLAY only; the rules live in
// backend/services/guarantee.py and config.guarantee_*. Keep these equal, and the
// Terms page (screens/Terms.jsx) words them too.
export const GUARANTEE_DAYS = 5;
export const GUARANTEE_FEE = 10000;            // Tomans kept back from a cash refund
export const GUARANTEE_PLANS = [2, 3];         // bought as such, paid in cash (not installments)
